import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography, Button } from '@mui/material';
import { Inbox as InboxIcon } from '@mui/icons-material';

const EmptyState = ({
  icon: CustomIcon,
  title,
  description,
  actionLabel,
  onAction,
  iconSize,
  maxWidth,
}) => {
  const Icon = CustomIcon || InboxIcon;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        py: 6,
        px: 3,
        maxWidth: maxWidth,
        mx: 'auto',
      }}
    >
      <Icon
        sx={{
          fontSize: iconSize,
          color: 'text.disabled',
          mb: 2,
        }}
      />

      <Typography
        variant="h6"
        color="text.secondary"
        gutterBottom
        sx={{ fontWeight: 500 }}
      >
        {title}
      </Typography>

      {description && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ mb: 3, maxWidth: 400 }}
        >
          {description}
        </Typography>
      )}

      {actionLabel && onAction && (
        <Button
          variant="contained"
          onClick={onAction}
        >
          {actionLabel}
        </Button>
      )}
    </Box>
  );
};

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actionLabel: PropTypes.string,
  onAction: PropTypes.func,
  iconSize: PropTypes.number,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

EmptyState.defaultProps = {
  icon: null,
  description: null,
  actionLabel: null,
  onAction: null,
  iconSize: 64,
  maxWidth: 600,
};

export default EmptyState;
